import { render, staticRenderFns } from "./Lottery2021.vue?vue&type=template&id=73eb5c30&scoped=true&"
import script from "./Lottery2021.vue?vue&type=script&lang=js&"
export * from "./Lottery2021.vue?vue&type=script&lang=js&"
import style0 from "./Lottery2021.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Lottery2021.vue?vue&type=style&index=1&id=73eb5c30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73eb5c30",
  null
  
)

export default component.exports